import React from "react";
import classNames from "classnames";
import { Checkmark } from "@app/components/common/icons";

type Props = {
  benefits: string[];
};

export const Benefits: React.FC<Props> = ({ benefits }) => {
  if (!benefits.length) {
    return null;
  }

  return (
    <div
      className={classNames(
        "grid h-fit grid-cols-1 gap-10 px-6",
        "lg:px-0",
        "xxl:grid-cols-2 xxl:gap-15",
      )}
    >
      {benefits.map((benefit) => (
        <div key={benefit} className="flex flex-row gap-5">
          <Checkmark className="h-10 w-10 flex-shrink-0" />
          <span className="text-regular">{benefit}</span>
        </div>
      ))}
    </div>
  );
};
